import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/SemitrailerReports';

const SemitrailerReportsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default SemitrailerReportsPage;
